/**
 * Hard-coded for v1 — Derek's setup is single-Safe, single-chain (Ethereum
 * mainnet). When this opens up to multi-safe / multi-chain we'll move these
 * into a routes config or settings panel.
 */
export const MAIN_SAFE = '0xa2c17579Ec04B8CAE30C34eb422b06a97BF05877'
export const MODULE_SAFE = '0x84229c4CA921d58F8aFE300A2DFfDc9B8Bc72865'
/**
 * Public-facing demo Safe used by the "Try the demo Safe" links on the
 * landing/onboarding cards. Currently has no modules enabled — opening it
 * walks visitors through SafeWard's onboarding flow rather than the
 * dashboard. Swap the address (or add modules) when we want a live demo.
 */
export const DEMO_SAFE = '0x69dCc957D20692D56b624666504813E799843E41'
export const CHAIN_ID = 1

/**
 * Public RPC endpoints for read-method proxying. We don't run a Worker for
 * this — for personal use the rate limits are fine. CORS-enabled. If a dApp
 * asks for a chain not in this map we still approve the namespace (so the
 * proposal succeeds) but read methods on that chain fail; sendTransaction
 * on a non-mainnet chain also fails because the Safe only exists on mainnet.
 */
export const PUBLIC_RPCS: Record<number, string> = {
  1: 'https://cloudflare-eth.com',
  10: 'https://mainnet.optimism.io',
  137: 'https://polygon-rpc.com',
  8453: 'https://mainnet.base.org',
  42161: 'https://arb1.arbitrum.io/rpc',
  43114: 'https://api.avax.network/ext/bc/C/rpc',
  56: 'https://bsc-dataseed.bnbchain.org',
  100: 'https://rpc.gnosischain.com',
  324: 'https://mainnet.era.zksync.io',
  534352: 'https://rpc.scroll.io',
  59144: 'https://rpc.linea.build',
}

export const WC_PROJECT_ID =
  import.meta.env.VITE_WC_PROJECT_ID ?? '5bae1dd28b27f6c3209d6629d410ceb2'

export const APP_METADATA = {
  name: 'SafeWard',
  description: 'Guardian-cosigned Safe wallet',
  url:
    typeof window !== 'undefined' && window.location.origin !== 'null'
      ? window.location.origin
      : 'https://safeward-ui.pages.dev',
  icons: ['https://safeward-ui.pages.dev/favicon.ico'],
}

export const SAFE_TX_SERVICE_URL =
  'https://safe-transaction-mainnet.safe.global'

/**
 * MultiSendCallOnly is used to atomically batch the calls in a
 * `wallet_sendCalls` request. We DELEGATECALL into it from the Main Safe,
 * which makes each call execute as if msg.sender were the Main Safe.
 *
 * v1.3.0 address — works against Safes deployed with Safe v1.3.0+. If Derek
 * ever moves to v1.4.1+ contracts, swap to `0x9641d764fc13c8B624c04430C7356C1C7C8102e2`.
 */
export const MULTI_SEND_CALL_ONLY = '0x40A2aCCbd92BCA938b02010E17A5b8929b49130D'
